module.exports = __webpack_public_path__ + "static/mnews05.png";